import { render, staticRenderFns } from "./CallIndicators.vue?vue&type=template&id=55ae4814&scoped=true&"
import script from "./CallIndicators.vue?vue&type=script&lang=js&"
export * from "./CallIndicators.vue?vue&type=script&lang=js&"
import style0 from "./CallIndicators.vue?vue&type=style&index=0&id=55ae4814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ae4814",
  null
  
)

export default component.exports